import { render, staticRenderFns } from "./EmailEditor.vue?vue&type=template&id=ee1220b8"
import script from "./EmailEditor.vue?vue&type=script&lang=js"
export * from "./EmailEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports